<template>
  <div>

    <div class="card mt-2" qid="basic-info-section">
      <div class="card-body pr-0 pl-0">

        <div class="content-view-body">

          <span class="btn btn-edit float-right" @click="showFormFunction(thirdParty)" v-if="!showForm">
            <font-awesome-icon icon="pen"/>
          </span>

          <b-form @submit="editTPFormSubmit" qid="edit-tp-form" v-if="showForm">
            <b-alert v-if="error.length"
                     show
                     variant="danger"
                     qid="edit-tp-error"
            >
              {{ error }}
            </b-alert>
            <div class="form-container">
              <b-form-group>
                <label qid="edit-tp-name-label">
                  {{ $t('maintenance.third_parties.create.name_label') }}
                </label>
                <b-form-input
                  qid="edit-tp-form-name"
                  type="text"
                  v-model="tpForm.name"
                  :maxLength="255"
                  required
                  :placeholder="$t('maintenance.third_parties.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('systems.create.owners_label') }}
                </label>
                <multiselect
                    v-model="selectedUsers"
                    :options="users"
                    :multiple="true"
                    :taggable="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    @search-change="loadUsers"
                    @remove="removeUserFromDropdown"
                    track-by="slug"
                    :placeholder="$t('systems.create.owners_placeholder')"
                    label="name"
                    qid="create-p-users-select"
                >
                  <template slot="tag" slot-scope="props">
                    <span></span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <Avatar :object="props.option" size="xs"></Avatar>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
                <div class="form-control auto-height mt-1" v-if="selectedUsers && selectedUsers.length">
                  <div v-for="(user, index) in selectedUsers" class="mt-1 mb-1">
                    <div class="row">
                      <div class="col-sm-1">
                        <font-awesome-icon
                          icon="star"
                          :class="{'color-yellow': user.owner, 'text-light': !user.owner}"
                          class="cursor-pointer"
                          @click="setOwner(index)"
                        />
                      </div>
                      <div class="col-sm-10">
                        <Avatar :object="user" size="xs" :noOwner="true"></Avatar>
                        <span class="ml-2">{{ user.name }}</span>
                      </div>
                      <div class="col-sm-1">
                        <font-awesome-icon
                          icon="times"
                          class="cursor-pointer"
                          @click="removeUser(index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <span class="text-light">
                  * {{ $t('maintenance.third_parties.create.owners_tip') }}
                </span>
              </b-form-group>
              <b-form-group>
                <label qid="create-do-tags-label">
                  {{ $t('processes.create.tags_label') }}
                </label>
                <multiselect
                    v-model="selectedTags"
                    :options="tags"
                    :multiple="true"
                    :taggable="true"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    @search-change="loadTags"
                    track-by="name_translated"
                    :placeholder="$t('processes.create.tags_placeholder')"
                    label="name_translated"
                    qid="create-do-tags-select"
                    @tag="addTag"
                ></multiselect>
              </b-form-group>
              <b-form-group :class="{'multiselect--show-input': typeInput.length}">
                <label qid="edit-tp-type-label">
                  {{ $t('maintenance.third_parties.create.type_label') }}
                </label>
                <multiselect
                    v-model="tpForm.type"
                    :options="types"
                    :placeholder="$t('maintenance.third_parties.create.type_placeholder')"
                    label="type"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    track-by="type"
                    :preserveSearch="true"
                    @search-change="loadTypes"
                    qid="edit-tp-form-type"
                >
                  <template slot="noResult" slot-scope="props">
                    {{ $t('maintenance.third_parties.create.type_no_results') }}
                  </template>
                </multiselect>
              </b-form-group>

            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="hideFormFunction"
                        qid="edit-tp-cancel-button"
              >
                {{ $t('maintenance.third_parties.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="edit-tp-submit-button"
                        v-if="isGranted([permissions.THIRD_PARTY_EDIT, permissions.THIRD_PARTY_EDIT_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.third_parties.create.submit') }}
              </b-button>
            </div>
          </b-form>

          <div v-if="!showForm">
            <label class="mt-3" v-if="thirdParty && thirdParty.name">
              {{ $t('systems.create.name_label') }}
            </label>
            <br>
            <span v-if="thirdParty && thirdParty.name">
              {{ thirdParty.name }}
            </span>
            <br>

            <label class="mt-3" v-if="thirdParty && thirdParty.name">
              {{ $t('systems.create.tags_label') }}
            </label>
            <br>
            <span class="badge mb-1 mr-1" v-for="tag in thirdParty.tags_translated" :title="tag.name_translated">
              <font-awesome-icon icon="tag"/>
              {{ tag.name_translated | truncate(35) }}
            </span>
            <br>

            <label class="mt-3" v-if="thirdParty">
              {{ $t('systems.create.owners_label') }}
            </label>
            <br>
            <span class="mr-1" v-for="user in thirdParty.users" qid="system-users-list">
              <Avatar :object="user" size="xs"></Avatar>
            </span>
            <br>

            <label class="mt-3" v-if="thirdParty">
              {{ $t('table.category') }}:
            </label>
            <br>
            <span class="mr-1" v-if="thirdParty.type">
              <span class="badge mb-1">
                <font-awesome-icon icon="shapes"/>
                {{thirdParty.type}}
              </span>
            </span>
            <br>

          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'BasicInfoTaskBlock',
    data: function() {
      return {
        thirdParty: {},
        showInput: false,
        showSingleLinkLabel: true,
        inputLink: '',
        showFullDescription: false,
        showFullContact: false,
        itemToDelete: {},
        tpForm: {
          name: '',
          description: '',
          contact_details: '',
          type: [],
          inspection: [],
          inspection_updated_at: '',
          data_processor_agreement: [],
          dpa_updated_at: '',
          countries: [],
          client:'',
          data_objects: [],
          tags: [],
          users: [],
          transfers_disclosures_third_countries: [],
          third_country_contract_type: [],
          third_country_contract_date: '',
          dpa_contract_type: []
        },
        error: '',
        countries: [],
        selectedCountries: [],
        inspectionItems: [
          { name: this.$t('maintenance.third_parties.inspection.no'), value: 'No' },
          { name: this.$t('maintenance.third_parties.inspection.external_audit'), value: 'External audit' },
          { name: this.$t('maintenance.third_parties.inspection.site_visit'), value: 'Site visit' },
          { name: this.$t('maintenance.third_parties.inspection.third-party_self-audit'), value: 'Third-party self-audit' }
        ],
        dpaItems: [
          { name: this.$t('maintenance.third_parties.data_processor_agreement.no'), value: 'No' },
          { name: this.$t('maintenance.third_parties.data_processor_agreement.yes'), value: 'Yes' },
          { name: this.$t('maintenance.third_parties.data_processor_agreement.n/a'), value: 'N/A' }
        ],
        dpaContractTypes: [
          { name: this.$t('maintenance.third_parties.dpa_contract_type.contract_model_clause'), value: 'Contract model clause' },
          { name: this.$t('maintenance.third_parties.dpa_contract_type.eu/us_privacy_shield'), value: 'EU/US Privacy Shield' },
          { name: this.$t('maintenance.third_parties.dpa_contract_type.adequacy_decision'), value: 'Adequacy decision' },
          { name: this.$t('maintenance.third_parties.dpa_contract_type.binding_corporate_rules'), value: 'Binding corporate rules' }
        ],
        transfersDisclosuresThirdCountries : [
          { name: this.$t('maintenance.third_parties.transfers_disclosures_third_countries.no'), value: 'No' },
          { name: this.$t('maintenance.third_parties.transfers_disclosures_third_countries.yes'), value: 'Yes' },
          { name: this.$t('maintenance.third_parties.transfers_disclosures_third_countries.n/a'), value: 'N/A' }
        ],
        thirdCountryContractTypes: [
          { name: this.$t('maintenance.third_parties.third_country_contract_type.contract_model_clause'), value: 'Contract model clause' },
          { name: this.$t('maintenance.third_parties.third_country_contract_type.eu/us_privacy_shield'), value: 'EU/US Privacy Shield' },
          { name: this.$t('maintenance.third_parties.third_country_contract_type.adequacy_decision'), value: 'Adequacy decision' },
          { name: this.$t('maintenance.third_parties.third_country_contract_type.binding_corporate_rules'), value: 'Binding corporate rules' }
        ],
        types: [],
        typeInput: '',
        dataObjects: [],
        selectedDataObjects: [],
        buttonDisabled: false,
        showDescriptionInput: false,
        processEditDescription: '',
        showContactInput: false,
        processEditContact: '',
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        tabIndex: 0,
        myGuides: [],
        selectedTags: [],
        tags: [],
        users: [],
        newTags: [],
        DOTableItems: [],
        DOLoading: false,
        selectedDO: [],
        selectedUsers: [],
        selectedDataObject: {},
        viewDataObjectActivitiesModal: false,
        selectedDataObjectActivities: [],
        showHistoryTab: false,
        showRiskTab: false,
        showDataObjectDescription: false,
        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        keywordValue: '',
        selectedSort: '',
        selectedDirection: '',
        myTasks: [],
        selectedItem: {},
        showTagsModal: false,
        viewDataModal: false,
        showAssessmentsTab: false,
        showForm: true
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      edit: {
        type: Boolean,
      },
      task: {},
      submitForm: {}
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadUsers();
        this.loadTags();
      },
      object: function (value) {
        let self = this;
        if (value && value.id) {
          this.thirdParty = value
        }
      },
      submitForm: function (value) {
        if (value) {
          if (this.showForm) {
            this.editTPFormSubmit()
          }
        }
      }
    },
    methods: {
      addTag(newTag) {
        const tag = {
          name: newTag,
          translatable: newTag,
          name_translated: newTag
        }
        this.selectedTags.push(tag)
        this.newTags.push(tag)
      },
      removeUser(index) {
        let selectedItem = this.selectedUsers[index]
        selectedItem.owner = false;
        this.$set(this.selectedUsers, index, selectedItem)
        // Remove item from selected users array
        this.selectedUsers.splice(index, 1);
      },
      removeUserFromDropdown(item) {
        item.owner = false;
      },
      setOwner(index) {
        let selectedItem = this.selectedUsers[index]
        _.forEach(this.selectedUsers, function (item) {
          item.owner = false;
        })
        selectedItem.owner = true;
        this.$set(this.selectedUsers, index, selectedItem)
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'contracts.view', params: { slug: this.thirdParty.slug }, query: { task: object.id }})
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.thirdParty.who_am_i,
              model_id: this.thirdParty.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Third party' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Third party',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showFormFunction(object) {
        this.loadTypes();
        this.loadTags();
        let self = this;
        this.showForm = true;

        if (object.users && object.users.length) {
          self.selectedUsers = [];
          _.forEach(object.users, function (user) {
            let matchedUser = _.cloneDeep(user)
            if (user.id == object.owner) {
              matchedUser.owner = true
            }
            self.selectedUsers.push(matchedUser)
          })
        }

        this.tpForm.transfers_disclosures_third_countries = []
        if (object.transfers_disclosures_third_countries) {
          this.tpForm.transfers_disclosures_third_countries = _.find(this.transfersDisclosuresThirdCountries, function(item) {
            return item.value === object.transfers_disclosures_third_countries;
          });
        }
        this.tpForm.third_country_contract_type = []
        if (object.third_country_contract_type) {
          this.tpForm.third_country_contract_type = _.find(this.thirdCountryContractTypes, function(item) {
            return item.value === object.third_country_contract_type;
          });
        }
        this.tpForm.dpa_contract_type = []
        if (object.dpa_contract_type) {
          this.tpForm.dpa_contract_type = _.find(this.dpaContractTypes, function(item) {
            return item.value === object.dpa_contract_type;
          });
        }

        if (object.inspection) {
          this.tpForm.inspection = _.find(this.inspectionItems, function(item) {
            return item.value === object.inspection;
          });
        }
        if (object.data_processor_agreement) {
          this.tpForm.data_processor_agreement = _.find(this.dpaItems, function(item) {
            return item.value === object.data_processor_agreement;
          });
        }
        // set selected countries on edit form
        if (object.countries && object.countries.length) {
          self.selectedCountries = [];
          _.forEach(object.countries, function (value, key) {
            _.find(self.countries, function(item) {
              if (item.name === value) {
                self.selectedCountries.push(item)
              }
            });
          })
        }

        if (object.tags_translated && object.tags_translated.length) {
          this.selectedTags = _.cloneDeep(object.tags_translated);
        }

        if (object.data_objects && object.data_objects.length) {
          this.selectedDataObjects = _.cloneDeep(object.data_objects);
        }

        if (object.type) {
          this.tpForm.type = []
          _.find(this.types, function(item) {
            if (item.type == object.type) {
              self.tpForm.type = item;
            }
          });
        }

        this.tpForm.slug = object.slug;
        this.tpForm.name = object.name;
        this.tpForm.description = object.description;
        this.tpForm.contact_details = object.contact_details;
        this.tpForm.inspection_updated_at = object.inspection_updated_at;
        this.tpForm.dpa_updated_at = object.dpa_updated_at;
        this.tpForm.third_country_contract_date = object.third_country_contract_date;
      },
      hideFormFunction() {
        this.typeInput = '';
        this.selectedUsers = []
        this.showForm = false;
      },
      editTPFormSubmit(evt) {
        this.buttonDisabled = true;
        var moment = require('moment');
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        let selectedOwner = false;

        if (evt) {
          evt.preventDefault();
        }

        this.tpForm.client = this.getClient.slug;
        this.tpForm.countries = [];

        for (var i = 0; i < this.selectedCountries.length; i++) {
          this.tpForm.countries.push(this.selectedCountries[i].name);
        }

        this.tpForm.users = [];
        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            this.tpForm.users.push(this.selectedUsers[i].id);
            if (this.selectedUsers[i].owner) {
              selectedOwner = true;
              this.tpForm.owner = this.selectedUsers[i].id;
            }
          }
        } else {
          selectedOwner = true;
        }

        this.tpForm.data_processor_agreement = this.tpForm.data_processor_agreement ? this.tpForm.data_processor_agreement.value : '';
        this.tpForm.inspection = this.tpForm.inspection ? this.tpForm.inspection.value : '';
        this.tpForm.transfers_disclosures_third_countries = this.tpForm.transfers_disclosures_third_countries ? this.tpForm.transfers_disclosures_third_countries.value : '';
        this.tpForm.third_country_contract_type = this.tpForm.third_country_contract_type ? this.tpForm.third_country_contract_type.value : '';
        this.tpForm.dpa_contract_type = this.tpForm.dpa_contract_type ? this.tpForm.dpa_contract_type.value : '';
        // transform selected date into correct format for API
        this.tpForm.inspection_updated_at = this.tpForm.inspection_updated_at ? moment(this.tpForm.inspection_updated_at).format('YYYY-MM-DD') : ''
        this.tpForm.dpa_updated_at = this.tpForm.dpa_updated_at ? moment(this.tpForm.dpa_updated_at).format('YYYY-MM-DD') : ''
        this.tpForm.third_country_contract_date = this.tpForm.third_country_contract_date ? moment(this.tpForm.third_country_contract_date).format('YYYY-MM-DD') : ''

        // this.tpForm.data_objects = []
        // if (this.selectedDataObjects && this.selectedDataObjects.length) {
        //   for (var i = 0; i < this.selectedDataObjects.length; i++) {
        //     this.tpForm.data_objects.push(this.selectedDataObjects[i].id);
        //   }
        // }

        this.tpForm.tags = [];
        if (this.selectedTags && this.selectedTags.length) {
          for (var i = 0; i < this.selectedTags.length; i++) {
            this.tpForm.tags.push(this.selectedTags[i].name_translated);
          }
        }

        if (this.typeInput && this.typeInput.length) {
          this.tpForm.type = this.typeInput
        } else {
          if (this.tpForm.type && this.tpForm.type.type) {
            this.tpForm.type = this.tpForm.type.type
          } else {
            this.tpForm.type = '';
          }
        }

        if (selectedOwner) {
          piincHttp.put('third-parties/' + this.tpForm.slug, this.tpForm).then(function(response) {
            self.hideFormFunction();
            self.buttonDisabled = false;
            self.thirdParty = response.data;
            self.$store.commit('storeUpdateContent', self.thirdParty);
            self.$emit('reloadContent', response.data);
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = this.$t('system.owners_error_message')
          this.buttonDisabled = false;
        }
      },
      loadCountries() {
        let self = this;
        piincHttp.get('countries').then(function(response) {
          self.countries = response.data
          self.showFormFunction(self.thirdParty)
        }, function() {});
      },
      loadTypes(query) {
        this.typeInput = query ? query : '';
        let self = this;
        piincHttp.get('/third-parties/types', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.types = response.data
          if (self.types && !self.types.length && !query) {
            self.types.push({type: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadTags(query) {
        let self = this;
        piincHttp.get('tags', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.tags = response.data
          if (self.tags && !self.tags.length && !query) {
            self.tags.push({name_translated: self.$t('system.no_results'), $isDisabled: true})
          }
          for (var i = 0; i < self.newTags.length; i++) {
            self.tags.push(self.newTags[i]);
          }
        }, function() {});
      },
      loadUsers(query) {
        let self = this;
        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 50
          }
        }).then(function(response) {
          self.users = response.data.items
          if (self.users && !self.users.length && !query) {
            self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadContent() {
        let self = this;
        piincHttp.get('third-parties/' + this.thirdParty.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.thirdParty = response.data;
        }, function() {});
      }
    },
    components: {
      Avatar
    },
    created () {
      this.thirdParty = this.object
      if (this.getClient && this.getClient.slug) {
        this.loadTypes()
        this.loadUsers()
        this.loadCountries()
      }
      if (this.thirdParty && this.thirdParty.id) {
        this.loadTasks('update_basic_info');
        this.loadContent()
      }

      this.loadGuides('update_basic_info');
    }
  }
</script>
